import { createFileRoute } from '@tanstack/react-router';
import styled from 'styled-components';
import api from '@/api';
import { NotFoundScreen } from '@/common/ErrorScreen';
import StudentStudyActivitiesTable from '@/tables/StudentStudyActivitiesTable';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/study-activities',
)({
  component: StudyActivitiesScreen,
});

function StudyActivitiesScreen() {
  const { memberId } = Route.useParams();
  const studentId = Number(memberId);

  // Legacy refuses this tab by not registering it, so a denied viewer gets a
  // 404 page, not a permission message. The probe answers 200 for every
  // signed-in caller, so one query decides the page, and it carries the caption
  // without widening `getStudent`, which study helpers can't call.
  //
  // This leaf's set is narrower than the shell's: the shell's `can_view`
  // includes the student themselves and only hides this tab for them, so a
  // student typing the URL reaches here. The probe admits supervisors only.
  const { data: access, isLoading } =
    api.getStudentStudyActivityAccess.useQuery({
      path: { student_id: studentId },
    });

  if (isLoading) return null;

  // Positive test: `access` is undefined on a 401, a 500 or a dropped
  // connection, and each of those is a refusal. `can_view === false` would
  // render the page on all three.
  if (access?.can_view !== true) return <NotFoundScreen />;

  return (
    <Container>
      <StudentStudyActivitiesTable
        studentId={studentId}
        studentName={access.display_name ?? ''}
      />
    </Container>
  );
}
const Container = styled.div`
  padding-top: 8px;
`;
